._container_1oxwx_1 {
  position: relative;
  width: 980px;
  height: 100%;
  margin: 0 auto; }
  ._container_1oxwx_1._mobile_1oxwx_6 {
    width: 320px; }
